import { render } from "./newGeneral.vue?vue&type=template&id=121de1bc"
import script from "./newGeneral.vue?vue&type=script&lang=js"
export * from "./newGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__